import React, { FC } from 'react'
import { ShareIcon, CheckIcon } from '@heroicons/react/outline'
import { Link } from 'react-router-dom'
import { Button } from '../../../../System'
import { useCopyToClipboard } from '../../../../utils/copyToClipboard'
import { StyledLinkCard } from '.'

type Props = {
  imageUrl: string;
  title: string;
  description: string;
  affiliateUrl: string;
  detailsUrl: string;
}

const LinkCard: FC<Props> = ({
  imageUrl, title, description, affiliateUrl, detailsUrl
}) => {
  const {
    isCopied,
    actions: { copyToClipboard }
  } = useCopyToClipboard()

  return (
    <StyledLinkCard>
      <div className="link-preview">
        <img src={imageUrl} alt="" />
      </div>
      <div className="link-details">
        <span className="link-title">{title}</span>
        <span className="link-description">{description}</span>
      </div>
      <div className="link-actions">
        <Link to={detailsUrl}>
          <Button className="details-btn" type="small" theme="ghost">
            View Details
          </Button>
        </Link>
        <Button
          iconPos="right"
          className="copy-btn"
          isDisabled={isCopied}
          onClick={() => copyToClipboard(affiliateUrl)}
        >
          {isCopied ? (
            <>
              COPIED <CheckIcon />
            </>
          ) : (
            <>
              COPY LINK <ShareIcon />
            </>
          )}
        </Button>
      </div>
    </StyledLinkCard>
  )
}

export default LinkCard
